import React from 'react';
// template components
import InformationalModule from '@nmx/template/dist/componentLibrary/modules/InformationalModule';
import Link from '@nmx/template/dist/componentLibrary/components/Link';
import Typography from '@nmx/template/dist/componentLibrary/foundations/Typography';
import WidowBlock from '@nmx/template/dist/componentLibrary/components/WidowBlock';

export default () => {
  return (
    <InformationalModule
      // configs
      sectionId='college-savings-plans-intro'
      moduleName='intro-module'
      disableBottomPadding={false}
      reverseContent={false}
      // content
      headingText={<>When should you start a college <WidowBlock>savings plan&#63;</WidowBlock></>}
      // column content
      introContent={(
        <>
          <Typography nextElement='button'>
            To give your family the most flexibility, starting early is key. With college costs continuing to rise, it&#39;s becoming more and more difficult to pay for higher education without turning to student loans&#8212;nowadays often six figures&#39; worth. No matter where you&#39;re starting from, our financial advisors will put together a savings plan to help make sure you have what you need.
          </Typography>
          <Link
            variant='buttonLinkPrimary'
            id='college-savings-plans-intro-section-fafa-cta'
            ariaLabel='Get started with a financial professional'
            linkUrl= '/find-a-financial-advisor/'>
            Get started
          </Link>
        </>
      )}
    />
  );
};
